import React from 'react'
import { createBrowserRouter, Navigate, RouterProvider, useParams } from 'react-router-dom'
import Layout from './Components/Layout'
import AboutUs from './Pages/AboutUs'
import AppLink from './Pages/AppLink'
import CategoryPage from './Pages/CategoryPage'
import Discussions from './Pages/Discussions'
import Explore from './Pages/Explore'
import Home from './Pages/Home'
import Login from './Pages/Login'
import MyTopics from './Pages/MyTopics'
import NotFound from './Pages/NotFound'
import PrivacyPolicy from './Pages/PrivacyPolicy'
import SearchResults from './Pages/SearchResults'
import SourcePage from './Pages/SourcePage'
import Sources from './Pages/Sources'
import Story from './Pages/Story'
import TermsOfUse from './Pages/TermsOfUse'
import TopicPage from './Pages/TopicPage'
import { slugify } from './Utils/text'

/* Old URLs keep working (the server also answers them with 301s,
   proxy/server.js in the pres repo). Old share links carry a news id. */
function OldArticleLink() {
  const { id } = useParams()
  return <Navigate to={/^\d+$/.test(id) ? `/prica/a${id}` : '/'} replace />
}

function OldPortalLink() {
  const { name } = useParams()
  return <Navigate to={`/izvor/${slugify(name)}`} replace />
}

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/istrazi', element: <Explore /> },
      { path: '/moje-teme', element: <MyTopics /> },
      { path: '/diskusije', element: <Discussions /> },
      { path: '/prijava', element: <Login /> },
      { path: '/prica/:id', element: <Story /> },
      { path: '/tema/:slug', element: <TopicPage /> },
      { path: '/izvor/:slug', element: <SourcePage /> },
      { path: '/izvori', element: <Sources /> },
      { path: '/kategorija/:slug', element: <CategoryPage /> },
      { path: '/pretraga', element: <SearchResults /> },
      { path: '/o-nama', element: <AboutUs /> },
      { path: '/app', element: <AppLink /> },
      { path: '/terms-of-use', element: <TermsOfUse /> },
      { path: '/privacy-policy.html', element: <PrivacyPolicy /> },

      { path: '/najcitanije', element: <Navigate to="/" replace /> },
      { path: '/najnovije', element: <Navigate to="/?prikaz=najnovije" replace /> },
      { path: '/search', element: <Navigate to="/istrazi" replace /> },
      { path: '/app-link', element: <Navigate to="/app" replace /> },
      { path: '/m-news', element: <Navigate to="/" replace /> },
      { path: '/share/:id', element: <OldArticleLink /> },
      { path: '/povezano/:id', element: <OldArticleLink /> },
      { path: '/portal/:name', element: <OldPortalLink /> },
      { path: '*', element: <NotFound /> },
    ],
  },
])

export default function App() {
  return <RouterProvider router={router} />
}
